var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInited
    ? _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("FormActionBtns", {
              attrs: {
                onAdd: _vm.add,
                hiddenAdd: !_vm.hasSettingUpdateAccess,
                onCancel: _vm.cancel,
                onSave: _vm.save,
                hiddenEdit: !_vm.showEdit,
                hiddenCancel: !_vm.hasList,
              },
              model: {
                value: _vm.status,
                callback: function ($$v) {
                  _vm.status = $$v
                },
                expression: "status",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tab-group" },
          [
            _vm.isAdd
              ? _c("div", { staticClass: "tab active" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("settings.department.newDepartment")) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.list, function (obj, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "tab",
                  class: !_vm.isAdd && index === _vm.curIndex ? "active" : "",
                  attrs: { title: obj.name },
                  on: {
                    click: function ($event) {
                      return _vm.onTabClick(obj, index)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(obj.shortname) + "\n    ")]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-container" },
          [
            _c(
              "div",
              _vm._l(_vm.items, function (item, index) {
                return _c("InputField", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  key: index,
                  attrs: {
                    autoTrim: true,
                    showFlag: true,
                    showColon: false,
                    showEmptyDash: true,
                    required: item.required,
                    readonly:
                      (!_vm.isEdit && !_vm.isAdd) ||
                      !_vm.hasSettingUpdateAccess,
                    label: _vm.$t("settings.department." + item.name),
                    value: _vm.formData[item.name],
                    dirtyCheck: true,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.onInputChange(item.name, val)
                    },
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            !_vm.isAdd ? _c("Sep") : _vm._e(),
            _vm._v(" "),
            !_vm.isAdd
              ? _c("TabCards", {
                  ref: "tabCards",
                  attrs: { formOptions: _vm.formOptions },
                  model: {
                    value: _vm.formData,
                    callback: function ($$v) {
                      _vm.formData = $$v
                    },
                    expression: "formData",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }